// extracted by mini-css-extract-plugin
export default {"wrap":"divisions_wrap__2zqMU","header":"divisions_header__QmpOu","row":"divisions_row__KIWzL","actions":"divisions_actions__rGt7H"};